import { logger } from "@/utils/logger";
import { supabase } from '@/integrations/supabase/client';

interface UserMessageEmailData {
  dealerId: number;
  message: string;
  sessionId: string;
  currentUrl?: string;
}

/**
 * Service to send user messages to dealer email if configured
 */
export class UserMessageEmailService {
  /**
   * Send user message email if dealer has email configured
   */
  static async sendUserMessageEmail(data: UserMessageEmailData): Promise<void> {
    try {
      logger.log('📧 UserMessageEmailService: Invoking send-user-message-email with data:', data);
      const { data: response, error } = await supabase.functions.invoke('send-user-message-email', {
        body: data
      });

      if (error) {
        console.error('❌ Failed to send user message email:', error);
      } else {
      }
    } catch (error) {
      console.error('💥 Error invoking send-user-message-email function:', error);
    }
  }
}